import { request, METHOD } from '../utils/request.js'

//发送验证码
//校区编号 campusCode;
// 学校编号 schoolCode;
// 身份证号码 idNumber;
// 学号 snCode;
// 学生姓名 stuName;
// 是否发送 flag N 否 Y 是
// 手机号 phoneNumber
export const sendPhoneCode = ({
  phoneNumber,
  sendMsgHead,
  schoolCode,
  snCode,
  campusCode,
}) => {
  return request(
    '/wxapi/platform/active/getVerificationCode',
    METHOD.POST,
    {
      phoneNumber,
      sendMsgHead,
      schoolCode,
      snCode,
      campusCode
    }
  )
}

// 发送验证码
export const sendPhoneCodeTwo = (data) => {
  return request(
    '/h5Mfitness/login/sendSms',
    METHOD.POST,
    data
  )
}


export const bind = ({
  code,
  schoolCode,
  snCode, // 学号
  stuName, // 姓名
  way = 5, // 登陆方式 5是微信
  vertificationCode, // 验证码
  campusCode, // 校区
  phoneNumber, // 手机号
  password
}) => {
  return request(
    '/wxapi/platform/active/bindLogin',
    METHOD.POST,
    {
      code,
      schoolCode,
      snCode,
      way,
      vertificationCode,
      campusCode,
      phoneNumber,
      stuName,
      password
  })
}

// 判断是否已绑定
export function hasBind({
  snCode,
  stuName
}) {
  return request(
    '/wxapi/platform/active/hasBind',
    METHOD.POST,
    {
      snCode,
      stuName
    }
  )
}
// 解除绑定
export function unBindLogin(data) {
  return request(
    `/h5Mfitness/login/loginOut?personType=${data.personType}`,
    METHOD.POST,
    data
  )
}
// 绑定登录
export function getOpenId(data) {
  return request(
    '/h5Mfitness/login/getOpenId',
    METHOD.POST,
    data
  )
}
export function getOpenIdQywx(data) {
  return request(
    '/h5Mfitness/login/getOpenIdQywx',
    METHOD.POST,
    data
  )
}

export function loginByOpenId(data) {
  return request(
    '/h5Mfitness/login/loginByOpenId',
    METHOD.POST,
    data
  )
}
export function mobileBind(data) {
  return request(
    '/h5Mfitness/login/mobileBind',
    METHOD.POST,
    data
  )
}
export function mobileBindPassword(data) {
  return request(
    'h5Mfitness/login/mobileBindPassword',
    METHOD.POST,
    data
  )
}

// 检测人员身份
export function checkPersonType(data) {
  return request(
    'h5Mfitness/com/checkPersonType',
    METHOD.POST,
    data
  )
}
